<div class="text-input-widget">
  <div class="infopanel">
    @if (currentChar == 'delete') {
      <span class="white delete-icon">{{tr('AICI_KEYBOARD_WIDGET_DELETE')}}</span>
    }
    @if (currentChar == 'space') {
      <span class="white space-icon">{{tr('AICI_KEYBOARD_WIDGET_SPACE')}}</span>
    }
    @if (currentChar == 'save') {
      <span class="white save-icon">{{tr('AICI_KEYBOARD_WIDGET_SAVE')}}</span>
    }
  </div>
  <div>
    <span class="specialchar icon inline-icon delete-icon" [ngClass]="{'iconBackAndDelete':currentChar == 'delete','iconBackAndDeleteGrey':currentChar != 'delete'}"></span>
    <span class="specialchar icon inline-icon space-icon"  [ngClass]="{'iconBlank':currentChar == 'space','iconBlankGrey':currentChar != 'space'}"></span>
    <span class="alphabet">
      <div class="slide" [ngStyle]="{'left':alphabetOffset}">
        @for (char of characters; track char) {
          <span class="char" [ngClass]="{'selected':currentChar == char}">{{char}}</span>
        }
      </div>
    </span>
    <span class="specialchar icon inline-icon save-icon" [ngClass]="{'iconSubmit':currentChar == 'save','iconSubmitGrey':currentChar != 'save'}">&gt;</span>
  </div>
</div>